import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.hr.records');
import { Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-hr-records',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.hr.records/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalLpsysadminHrRecordsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() selfOnly: boolean = false;

    public loaded: boolean = false;
    public users: any[] = [];
    public records: any[] = [];
    public selectedUserId: string = '';
    public selectedUser: any = {};
    public selectedCompany: string = '';
    public companyOptions: any[] = [];
    public record: any = {};
    public summary: any = {};
    public legal: any[] = [];

    public statusMap: any = {
        active: '재직',
        inactive: '비활성',
        on_leave: '휴직',
        retired: '퇴직',
        dismissed: '해고',
        deceased: '사망',
    };

    public async ngOnInit() {
        await this.service.init();
        if (!this.selfOnly) {
            await this.service.auth.allow.membership(['super_admin'], '/admin/system/dashboard');
        }
        await this.load();
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("load", {
            user_id: this.selfOnly ? '' : this.selectedUserId,
            company_name: this.selfOnly ? '' : this.selectedCompany,
            self_only: this.selfOnly ? '1' : '',
        });
        if (code === 200) {
            this.users = data.users || [];
            this.records = data.records || [];
            this.selectedUserId = data.selected_user_id || '';
            this.selectedUser = data.selected_user || {};
            this.selectedCompany = data.selected_company || this.selectedCompany;
            this.companyOptions = data.company_options || [];
            this.record = data.record || {};
            this.summary = data.summary || {};
            this.legal = data.legal || [];
        } else {
            this.service.alert.error(data?.message || "인사기록카드를 불러오지 못했습니다.");
        }
        this.loaded = true;
        await this.service.render();
    }

    public async applyCompanyFilter() {
        if (this.selfOnly) return;
        this.selectedUserId = '';
        await this.load();
    }

    public async selectRecord(item: any) {
        if (this.selfOnly) return;
        this.selectedUserId = item.user_id;
        await this.load();
    }

    public async save() {
        if (this.selfOnly) return;
        const res = await wiz.call("save", {
            ...(this.record || {}),
            company: this.record?.company || this.selectedCompany,
            user_id: this.selectedUserId,
        });
        if (res.code === 200) {
            this.service.alert.success("인사기록카드가 저장되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "인사기록카드 저장에 실패했습니다.");
        }
    }

    public statusLabel(value: string): string {
        return this.statusMap[value] || value || '-';
    }

    public statusClass(value: string): string {
        const map: any = {
            active: 'bg-emerald-100 text-emerald-700',
            on_leave: 'bg-blue-100 text-blue-700',
            inactive: 'bg-zinc-100 text-zinc-600',
            retired: 'bg-zinc-100 text-zinc-600',
            dismissed: 'bg-red-100 text-red-700',
            deceased: 'bg-zinc-900 text-white',
        };
        return map[value] || 'bg-zinc-100 text-zinc-600';
    }

    public missingText(item: any): string {
        const fields = item?.missing_fields || [];
        if (!fields.length) return '완료';
        return `${fields.length}개 누락`;
    }

    public pageTitle(): string {
        return this.selfOnly ? '내 인사기록카드' : '인사기록카드';
    }

    public pageDescription(): string {
        return this.selfOnly ? '내 근로자명부 및 고용기록을 조회합니다.' : '총괄관리자 전용 근로자명부 및 고용기록 관리입니다.';
    }

    public isReadonly(): boolean {
        return this.selfOnly;
    }
}

export default PortalLpsysadminHrRecordsComponent;